import { defineComponent as q, ref as f, computed as I, toRef as M, toValue as U, isRef as x, watch as m, toRaw as z, createElementBlock as G, openBlock as H, mergeProps as J, renderSlot as K, unref as p, onMounted as L, onUnmounted as Q } from "vue";
import T from "core-js-pure/actual/structured-clone";
import { isEmpty as V } from "../../utils/isEmpty.js";
import { isEqual as b } from "../../utils/isEqual.js";
import { subscribe as W, unsubscribe as X } from "./Form.actions.js";
import { makeValidate as Y, mergeFormValues as Z } from "./Form.helpers.js";
import { useValidation as w } from "./composables/useValidation.js";
const le = /* @__PURE__ */ q({
  name: "RevForm",
  inheritAttrs: !1,
  __name: "Form",
  props: {
    name: { default: void 0 },
    initialValues: {},
    validate: { default: () => Y() }
  },
  emits: ["init", "visible-errors-change", "on-submit-failed", "submit"],
  setup(C, { emit: O }) {
    const i = C, o = O;
    function R(e) {
      function a(s) {
        const l = e[s.type];
        l && l(s.payload);
      }
      L(() => {
        i.name && W(i.name, a);
      }), Q(() => {
        i.name && X(i.name, a);
      });
    }
    const r = f(), j = I(() => r.value ? Object.values(r.value).some(Boolean) : !1), h = (e) => {
      if (!e) {
        r.value = {};
        return;
      }
      r.value = Object.fromEntries(
        Object.keys(e).map((a) => [a, !1])
      );
    }, t = f({}), u = f(), _ = I(() => b(t.value, i.initialValues)), B = M(
      () => x(i.validate) ? U(i.validate) : i.validate
    ), {
      validateAllFields: v,
      validateOnlyDirtyAndInErrorFields: S,
      visibleErrors: y,
      hasVisibleError: P,
      makeErrorsVisible: c,
      isValid: n,
      resetValidation: E,
      errors: d
    } = w(
      t,
      r,
      B
    );
    function F(e, a = t.value) {
      t.value = { ...Z(a, e) }, u.value = { ...t.value }, v();
    }
    function g(e = {}) {
      h(t.value), F(e);
    }
    m(
      () => i.initialValues,
      (e, a) => {
        E();
        const s = z(e), l = T(s);
        g(l), a || o("init", { isValid: n.value, values: l });
      },
      { immediate: !0 }
    ), m(
      () => ({ ...y.value }),
      (e, a) => {
        !V(e) && !b(e, a) && o("visible-errors-change", { errors: e });
      },
      { immediate: !0 }
    ), m(
      t,
      (e) => {
        e && (Object.keys(e).forEach((a) => {
          var A;
          if (!r.value)
            return;
          const s = !V(u.value) && !b((A = u.value) == null ? void 0 : A[a], e[a]), l = r.value[a] === !0, $ = s || l;
          r.value[a] = $;
        }), u.value = { ...e }, S());
      },
      { deep: !0 }
    ), m(
      () => i.validate,
      async () => {
        v(), c();
      },
      {
        deep: !0,
        // Do not show the validation errors on the first render.
        // Note that `immediate: false` is the default value
        // but we keep it here for clarity.
        immediate: !1
      }
    );
    function k(e) {
      e && e.preventDefault(), v(), c(), h(t.value), n.value ? o("submit", t.value) : o("on-submit-failed", { errors: d.value });
    }
    function D() {
      return E(), g(i.initialValues), { isValid: n.value, values: t.value };
    }
    return R({
      submit: () => k(),
      reset: D,
      setValues: (e) => F(e),
      setErrors: function(a) {
        V(a) || (d.value = { ...d.value, ...a }, c());
      }
    }), (e, a) => (H(), G("form", J(e.$attrs, { onSubmit: k }), [
      K(e.$slots, "default", {
        dirtyFields: r.value,
        errors: p(y),
        hasError: p(P),
        hasInitialValues: _.value,
        isDirty: j.value,
        isValid: p(n),
        reset: D,
        values: t.value
      })
    ], 16));
  }
});
export {
  le as default
};
